// extracted by extract-css-chunks-webpack-plugin
module.exports = {"input":"form-control-clipboard__input___1IDSQ"};
    if(module.hot) {
      // 1747710626591
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  